let cachedSpellData = null;

async function getSpellAbbrevs() {
    if (!cachedSpellData) {
        try {
            cachedSpellData = await fetch('config/spell-abbrevs.json').then(response => response.json());
        } catch (error) {
            console.error('Error fetching spell abbreviations:', error);
            cachedSpellData = {}; // fallback to an empty object
        }
    }
    return cachedSpellData;
}

async function spell_translate(spellname) {
    const spell_lowered = spellname.toLowerCase();
    const spellAbbreviations = await getSpellAbbrevs();

    if (spell_lowered in spellAbbreviations) {
        // console.log(spell_lowered, spellAbbreviations[spell_lowered]);
        return spellAbbreviations[spell_lowered];
    } else {
        return 'Spell not found';
    }
}

export default spell_translate;